import axios, { AxiosInstance } from 'axios'

const apiClient: AxiosInstance = axios.create({
  baseURL: 'https://api.daltoinvestments.com/api', // Adjust this to match your Laravel backend URL (e.g., http://your-laravel-api.test/api)
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

// Add a request interceptor to include the Sanctum token (if available) in the Authorization header
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default apiClient
